import { Helmet } from 'react-helmet-async';
import Button from '../components/ui/Button';
import './NotFound.scss';

function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Valendris</title>
      </Helmet>
      <section className="not-found">
        <div className="not-found-container container">
          <div className="not-found-content">
            <h1 className="not-found-code">404</h1>
            <h2 className="not-found-title">Page Not Found</h2>
            <p className="not-found-description">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <div className="not-found-actions">
              <Button to="/">Back to Home</Button>
              <Button to="/contact" variant="secondary">Contact Me</Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound;
